import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import instance from "../../../config/Config";

const initialState = {
    data: null,
    loading: false,
    error: null,
    count: null,
    eventsList: null,
    response: null,

};
export const GetEventList = createAsyncThunk(
    "GetEventList",
    async (body) => {
        try {
            const response = await instance.get(`/remark/festival-banner/festival-banner-list?page=${body.page}&search=${body.search}&startDate=${body.startDate}&endDate=${body.endDate}`)
            return response.data;
        } catch (error) {
            throw error;
        }
    }
)

export const addFestivalBanner = createAsyncThunk(
    "addFestivalBanner",
    async (body) => {
        const formData = new FormData();
        formData.append("fb_festival_banner_name", body.fb_festival_banner_name);
        formData.append("fb_image", body.fb_image[0]);
        formData.append("fb_link_url", body.fb_link_url);
        formData.append("fb_description", body.fb_description);
        formData.append("fb_start_date", body.fb_start_date);
        formData.append("fb_end_date", body.fb_end_date);
        formData.append("fb_status", body.fb_status);
        formData.append("fb_coupon_name", body.fb_coupon_name);
        formData.append("fb_coupon_code", body.fb_coupon_code);
        formData.append("fb_user_type", body.fb_user_type);
        try {
            const response = await instance.post("/remark/festival-banner/festival-banner-add", formData);
            return response.data;
        } catch (error) {
            throw error;
        }
    }
)

// toggle status switch 
export const UpdateStatusSwitch = createAsyncThunk(
    "UpdateStatusSwitch",
    async (data) => {
        try {

            const response = await instance.post(`/remark/festival-banner/festival-banner-status-update?id=${data?.id}&status=${data?.status}`)
            return response.data
        } catch (error) {
            throw error;
        }
    }
)

export const EventsSlice = createSlice({
    name: "EventsSlice",
    initialState,
    reducers: {},
    extraReducers: (builder) => {

        builder.addCase(GetEventList.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(GetEventList.fulfilled, (state, action) => {
            state.loading = false;
            state.eventsList = action.payload;
            state.count = action.payload?.count;
        });
        builder.addCase(GetEventList.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        builder.addCase(addFestivalBanner.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(addFestivalBanner.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
            state.count = action.payload?.count;
        });
        builder.addCase(addFestivalBanner.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
        builder.addCase(UpdateStatusSwitch.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(UpdateStatusSwitch.fulfilled, (state, action) => {
            state.loading = false;
            state.response = action.payload;
            state.count = action.payload?.count;
        });
        builder.addCase(UpdateStatusSwitch.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    },
});

export default EventsSlice.reducer;
